import { render, staticRenderFns } from "./BoxWrap.vue?vue&type=template&id=71372680&scoped=true&"
import script from "./BoxWrap.vue?vue&type=script&lang=js&"
export * from "./BoxWrap.vue?vue&type=script&lang=js&"
import style0 from "./BoxWrap.vue?vue&type=style&index=0&id=71372680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71372680",
  null
  
)

export default component.exports